<template>
  <div class="table-container">
    <el-table :data="tableData" stripe border="" style="width: 100%">
      <el-table-column prop="domain_name" label="域名"></el-table-column>
      <el-table-column prop="status" label="全站加速"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <div v-if="scope.row.cdn_flag">
            <el-button type="primary" @click="toSetUpDns(scope.row)">DNS解析</el-button>
            <el-button @click="toSetUpCertificate(scope.row)" type="primary">设置证书</el-button>
            <el-button @click="toSetUpOptimization(scope.row)" type="primary">设置优化</el-button>
          </div>
          <div v-else>
            <el-button
              type="primary"
              :loading="scope.row.loading"
              @click="toSpeedUp(scope.row)"
            >一键加速</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import request from '../../api/request'
import { setTimeout } from 'timers'
// import { format } from 'date-fns'
export default {
    data() {
        return {
            tableData: [],
        }
    },
    created() {
        this.getItemList()
    },
    methods: {
        async getItemList() {
            // const params = {
            //   range: [0, 1e6]
            // };
            const resp = await request.aliyun.post('domain_get')
            this.tableData = resp.data.list.map((item) => {
                return {
                    ...item,
                    status: item.cdn_flag ? '已加速' : '未加速',
                    loading: false,
                }
            })
        },
        async toSpeedUp(row) {
            row.loading = true
            await request.aliyun.post('cdn_domain_add', {
                domain_name: row.domain_name,
            })
            this.checkAddStatus(row.domain_name)
        },
        async checkStatus(domain) {
            const resp = await request.aliyun.post('cdn_domain_info_get', {
                domain_name: domain,
            })
            return resp
        },
        async checkAddStatus(domain) {
            const resp = await request.aliyun.post('cdn_domain_progress_get', {
                domain_name: domain,
            })
            if (resp.data.current === resp.data.total) {
                this.tableData.map((item) => {
                    if (item.domain_name === domain) {
                        item.loading = false
                        this.$message.success('加速成功')
                    }
                })
            } else {
                setTimeout(() => {
                    this.checkAddStatus(domain)
                }, 1000)
            }
        },
        async toSetUpDns(row) {
            const status = await this.checkStatus(row.domain_name)
            if (status.data.dns_flag) {
                this.$message.success('已设置')
            } else {
                await request.aliyun.post('cdn_domain_dns_set', {
                    domain_name: row.domain_name,
                })
                this.$message.success('设置成功')
            }
        },
        async toSetUpCertificate(row) {
            const status = await this.checkStatus(row.domain_name)
            if (status.data.cate_flag) {
                this.$message.success('已设置')
            } else {
                await request.aliyun.post('cdn_domain_cate_set', {
                    domain_name: row.domain_name,
                })
                this.$message.success('设置成功')
            }
        },
        async toSetUpOptimization(row) {
            const status = await this.checkStatus(row.domain_name)
            if (status.data.optimize_flag) {
                this.$message.success('已设置')
            } else {
                await request.aliyun.post('cdn_domain_config_set', {
                    domain_name: row.domain_name,
                })
                this.$message.success('设置成功')
            }
        },
    },
}
</script>

<style scoped>
.head {
    text-align: right;
    margin-bottom: 30px;
}
.item {
    width: 200px;
}
.table-container {
    height: 400px;
}
</style>
